<script>
  export let style = undefined;
  export let noGridOnMobile = false;
  export let fullWidth = false;
</script>

<style>
  div {
    width: 100%;
    max-width: 1280px;
    min-height: 50%;
    margin: auto;
  }

  .fullWidth {
    max-width: none;
  }

  .all {
    display: grid;
    grid-template-columns: 2rem repeat(10, calc((100% - 4rem) / 10)) 2rem;
    grid-template-rows: repeat(12, calc(100% / 12));
  }

  @media screen and (min-width: 640px) {
    div {
      min-height: 70%;
    }
    .above-mobile {
      display: grid;
      grid-template-columns: 2rem repeat(10, calc((100% - 4rem) / 10)) 2rem;
      grid-template-rows: repeat(12, calc(100% / 12));
    }
  }
</style>

<div class={noGridOnMobile ? 'above-mobile' : 'all'} class:fullWidth {style}>
  <slot />
</div>
